import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Loader2, ShieldAlert } from 'lucide-react';

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-[70vh] grid place-items-center">
        <Loader2 className="animate-spin text-ktc-green" size={40} />
      </div>
    );
  }
  if (!user) return <Navigate to="/admin/login" replace />;
  if (!user.is_admin) {
    return (
      <div className="min-h-[70vh] grid place-items-center px-6">
        <div className="text-center max-w-md">
          <ShieldAlert className="mx-auto text-ktc-gold" size={48} />
          <h1 className="font-serif text-3xl font-semibold text-ktc-green mt-4">Access Restricted</h1>
          <p className="text-ktc-charcoal/70 mt-3">The account <strong>{user.email}</strong> is not authorised for admin access. Please sign in with an approved account.</p>
        </div>
      </div>
    );
  }
  return children;
};

export default ProtectedRoute;
